import { render, staticRenderFns } from "./rateAdd.vue?vue&type=template&id=1da40fdc"
import script from "./rateAdd.vue?vue&type=script&lang=js"
export * from "./rateAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports